import { useCallback } from 'react'
import ApiService from '../../services/ApiService'

const InteractorCompanyView = () => {
  const companyView = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/account-company/view', payload, (response) => {
      if (response.status_code === 200) {
        callback(response.data)
      } else {
        callback(null)
      }
      loading(false)
    })
  }, [])
  return { companyView }
}

export default InteractorCompanyView
